import { assets } from "../../assets";
import { BrandImage } from "../BrandImage/BrandImage";
import { Wordmark } from "../BrandImage/Wordmark";
import { Icon, type IconName } from "../../icons";

const POINTS: { icon: IconName; text: string }[] = [
  { icon: "shield", text: "Two-step verification on every account" },
  { icon: "activity", text: "Every action is recorded in the audit trail" },
  { icon: "lock", text: "Personal data handled under Chilean Law 21.719" },
];

const SHAPES: { cls: string; style: React.CSSProperties }[] = [
  { cls: "nb-shape-quarter", style: { width: 220, height: 220, right: -60, bottom: -60, background: "rgba(2,156,251,.14)", ["--t" as string]: "16s" } },
  { cls: "nb-shape-leaf", style: { width: 64, height: 64, right: "22%", top: "18%", background: "rgba(207,227,245,.10)", ["--t" as string]: "11s", ["--d" as string]: "-3s" } },
  { cls: "nb-shape-disc", style: { width: 14, height: 14, right: "34%", bottom: "26%", background: "var(--azul-byte)", opacity: 0.8, ["--t" as string]: "9s", ["--d" as string]: "-5s" } },
  { cls: "nb-shape-disc", style: { width: 120, height: 120, left: -40, top: "38%", border: "1px solid rgba(207,227,245,.12)", ["--t" as string]: "14s", ["--d" as string]: "-7s" } },
];

/** The navy panel on the left of every auth step: decoration only, hidden from screen readers. */
export function AuthBrand(): React.JSX.Element {
  return (
    <aside className="nb-auth-brand" aria-hidden="true">
      <div className="nb-shapes">
        {SHAPES.map((s, i) => (
          <span key={i} className={`nb-shape ${s.cls}`} style={s.style} />
        ))}
      </div>
      <BrandImage src={assets.logoDark} className="nb-auth-logo" fallback={<Wordmark className="nb-auth-logo is-on-navy" />} />
      <div className="nb-auth-hero">
        <h1>Nabble Suite</h1>
        <p>Manage all of your organization's information in one place.</p>
        <ul className="nb-auth-points">
          {POINTS.map((p, i) => (
            <li key={p.text} style={{ ["--i" as string]: i }}>
              <span>
                <Icon name={p.icon} />
              </span>
              {p.text}
            </li>
          ))}
        </ul>
      </div>
      <div className="nb-auth-meta">
        <span>© 2026 Nabble</span>
      </div>
    </aside>
  );
}
